var _rect, _line, _polyline, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMigrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18,
    width: 18,
    height: 36,
    rx: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 32,
    x2: 36,
    y2: 32
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "33,27 39,32 33,37"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 18,
    width: 18,
    height: 36,
    rx: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrate);
export default __webpack_public_path__ + "static/media/migrate.8c9f97bec4947e725174aa4f42bc9f15.svg";
export { ForwardRef as ReactComponent };